import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import dayjs from "dayjs";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import "./date-input-filter.scss";

/* eslint-disable-next-line */
export interface DateInputFilterProps {
  //input props
  name: string;
  value?: Dayjs;
  label?: string;
  placeholder?: string;
  assistiveText?: string;
  iconButton?: string;
  actionIconButton?: () => void;
  required?: boolean;
  validationIcons?: boolean;
  disabled?: boolean;
  minDate?: Dayjs;
  maxDate?: Dayjs;
  hiddenDay?: boolean;
  onChange?: (value: any) => void;
}

export function DateInputFilter(props: DateInputFilterProps) {
  const [date, setDate] = useState<Dayjs | null>(
    props.value ? dayjs(props.value) : null
  );

  useEffect(() => {
    if (date !== props.value && !props.value) {
      setDate(null);
    } else if (date !== props.value && props.value) {
      setDate(props.value);
    }
  }, [props.value]);

  return (
    <div className="date-container">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {/* <DemoContainer components={["DatePicker"]}> */}
        <DatePicker
          name={props.name}
          format="MM/YYYY"
          value={date ?? date}
          label={props.label}
          // onFocus={(e: any) => {
          //   e.target.placeholder = props.placeholder ? props.placeholder : "";
          // }}
          onChange={(date) => {
            if (props.onChange !== undefined) props.onChange(date);
            setDate(date);
          }}
          // minDate={dayjs("2024-12-12")}
          // minDate={props.minDate ? dayjs(props.minDate) : null}
          maxDate={props.maxDate ?? props.maxDate}
          disabled={props.disabled}
          // openTo="month"
          views={props.hiddenDay ? ["month", "year"] : ["day", "month", "year"]}
        />
        {/* </DemoContainer> */}
      </LocalizationProvider>

      {props.assistiveText && (
        <p className="assistive-text">{props.assistiveText}</p>
      )}
    </div>
  );
}

export default DateInputFilter;
